/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="21.74"
        height="21.76"
        viewBox="0 0 21.74 21.76"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m20.18 13.48-9.93-3.46.34 10.51a9.71 9.71 0 1 1 10-9.44 10 10 0 0 1-.38 2.44m-.89 2.15c-.12.22-.25.43-.38.63a10.52 10.52 0 0 1-1.12 1.36l-.15.15c-.15.15-.31.29-.48.43l-.24.2-.46.35-.29.19c-.16.11-.33.21-.49.3l-.28.16-.52.25-.29.13c-.24.1-.48.19-.73.27l-.33.09-.48.13-.32.07-.65.1h-.28l-.29-8.76 8.26 2.88a9.18 9.18 0 0 1-.48 1M10.89 0a10.88 10.88 0 0 0 0 21.76h1.23a5.41 5.41 0 0 0 .87-.13l.26-.06c.21-.05.43-.1.66-.17l.38-.11.52-.19.47-.2.42-.2q.28-.13.57-.3l.34-.2q.33-.21.66-.45l.16-.1.11-.1a9.06 9.06 0 0 0 .75-.64l.22-.19c.18-.18.36-.38.53-.57a11.15 11.15 0 0 0-2.92-16.77A10.8 10.8 0 0 0 10.88.02"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>
    );
  }
}

Icon.displayName = 'PieChartIcon';

export default Icon;
